<template>
	<Dropdown :options="options" :disabled="false" name="zipcode" :maxItem="maxItem" :placeholder="placeholder"> </Dropdown>
</template>

<script>
import Dropdown from "vue-simple-search-dropdown";
export default {
	props: {
		options: {
			type: Array
		},
		placeholder: {
			type: String,
			default: ""
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		maxItem: {
			type: Number,
			default: 5
		}
	},
	components: { Dropdown },

	methods: {
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		}
	}
};
</script>
